import aiValidationService from '@/services/aiValidationService';

export const moduleAIValidation = {
  namespaced: true,
  state: {
    contacts: [],
    loading: false,
  },
  getters: {
    getContacts: s => s.contacts,
    getLoading:  s => s.loading,
  },
  mutations: {
    setContacts(state, contacts) { state.contacts = contacts; },
    setLoading(state, val)       { state.loading = val; },
  },
  actions: {
    async fetchContacts({ commit }) {
      commit('setLoading', true);
      try {
        const res = await aiValidationService.getContacts();
        commit('setContacts', res.data);
      } finally {
        commit('setLoading', false);
      }
    },
  },
};
